const marketingActions = {
  modal: {
    type: 'Тип',
    bonus: 'Платіж',
    discount: 'Кампанія',
    date: 'Дата',
    store: 'Магазин',
    country: 'Країна',
    products: 'Товари',
    name: 'Назва',
    actionText: 'Текст дії',
    priceplans: 'Цінові плани',
    storeMarketingAction: 'Додати нову дію',
    updateMarketingAction: 'Оновити дію',
  },
  messages: {
    success: 'Дію успішно збережено',
    destroy: 'Дію успішно видалено',
  },
  actions: 'Маркетингові дії',
  showing: 'показується',
  actionsOf: 'дії з',
  noActionsFound: 'Дії не знайдено',
  addNew: 'Додати нову дію',
};

export default marketingActions;
